import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

type DatadogPublicEnv = {
    NEXT_PUBLIC_DD_ENV?: string
    NEXT_PUBLIC_DD_CLIENT_TOKEN?: string
    NEXT_PUBLIC_DD_APPLICATION_ID?: string
}

declare global {
    interface Window {
        __NEXT_PUBLIC_DD__?: DatadogPublicEnv
    }
}

function getDatadogPublicConfig() {
    const runtime = typeof window !== 'undefined' ? window.__NEXT_PUBLIC_DD__ : undefined

    return {
        env: runtime?.NEXT_PUBLIC_DD_ENV || process.env.NEXT_PUBLIC_DD_ENV || 'local',
        clientToken: runtime?.NEXT_PUBLIC_DD_CLIENT_TOKEN || process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
        applicationId: runtime?.NEXT_PUBLIC_DD_APPLICATION_ID || process.env.NEXT_PUBLIC_DD_APPLICATION_ID,
    }
}

export function initDatadog() {
    if (typeof window === 'undefined') return

    const { env, clientToken, applicationId } = getDatadogPublicConfig()

    if (env === 'local' || !clientToken || !applicationId) return

    const ddConfig = {
        clientToken,
        site: 'datadoghq.eu',
        service: 'doctemplate-frontend',
        env,
    }

    datadogRum.init({
        ...ddConfig,
        clientToken,
        applicationId,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [`${window.location.origin}/api`],
    })

    datadogLogs.init({
        ...ddConfig,
        clientToken,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    })
}
